import { render, staticRenderFns } from "./ManageRates.vue?vue&type=template&id=51863eae"
import script from "./ManageRates.vue?vue&type=script&lang=js"
export * from "./ManageRates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports